export default __webpack_public_path__ + "static/media/connecting-interpreter-2.8a06a4ad.svg";